// src/pages/DataDeletion.jsx
import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

const DataDeletion = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        my: 4,
        px: { xs: 2, sm: '5vw', md: '7vw' },
      }}
    >
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main' }}>
          Data Deletion Request
        </Typography>
        <Typography variant="subtitle1" sx={{ color: 'text.secondary', mt: 1 }}>
          How to request deletion of your Gupta Decor account and personal data
        </Typography>
      </Box>

      <Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          If you have used Gupta Decor (guptadecoration.com) and want your personal data deleted,
          follow the steps below. This page also serves as our data deletion instructions for
          Facebook / Meta app review.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          How to Request Deletion
        </Typography>
        <Typography component="ol" variant="body1" sx={{ pl: 3, mb: 2 }}>
          <li>
            Send an email to{' '}
            <Link href="mailto:nilesh@guptadecoration.com" underline="hover">
              nilesh@guptadecoration.com
            </Link>{' '}
            from the email address associated with your account.
          </li>
          <li>
            Use the subject line: <strong>Data Deletion Request</strong>.
          </li>
          <li>
            In the message body, include:
            <Typography component="ul" variant="body1" sx={{ pl: 3, mt: 1, mb: 1 }}>
              <li>Your full name</li>
              <li>The registered email address for your Gupta Decor account</li>
              <li>Optional: relevant order IDs if you know them</li>
            </Typography>
          </li>
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          What We Delete
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Upon verifying your request, we will delete or permanently anonymize:
        </Typography>
        <Typography component="ul" variant="body1" sx={{ pl: 3, mb: 2 }}>
          <li>Your user account and profile information (name, email, phone, address)</li>
          <li>Your shopping cart data</li>
          <li>Authentication credentials associated with your account</li>
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          What May Be Retained
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Order records may be retained for a limited period where required for legal, tax, or
          accounting obligations. Where retention is required, we will anonymize personal
          identifiers so the records can no longer be linked to you, except where law requires
          otherwise.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          Response Time
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We will acknowledge your request by email and complete deletion within{' '}
          <strong>30 days</strong> of receiving a verified request.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          Contact
        </Typography>
        <Typography variant="body1">
          Questions about this process:{' '}
          <Link href="mailto:nilesh@guptadecoration.com" underline="hover">
            nilesh@guptadecoration.com
          </Link>
          . For our full privacy practices, see our{' '}
          <Link href="/privacy" underline="hover">
            Privacy Policy
          </Link>
          .
        </Typography>
      </Box>
    </Container>
  );
};

export default DataDeletion;
